import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* cancelLogin(action) {
  var payload = {
    action: "portal/cancelLogin",
    strategy: action.strategy,
    session: action.session,
  };
  yield put(serverRequest(payload));
}

export default cancelLogin;
